import { render, staticRenderFns } from "./OfferTraid.vue?vue&type=template&id=cf4f87ca&"
import script from "./OfferTraid.vue?vue&type=script&lang=js&"
export * from "./OfferTraid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports